import {buildUrl} from "../service/url-builder";
const axios = require('axios');

function cleanupData(configName, runContext){
    return axios.delete(buildUrl("/cleanup"),
        {
            headers: {},
            data: {
                runContext: runContext,
                configName: configName
            }
    }).then(response => {
        return response.data;
    });
}

export {cleanupData}